import './QuizNavigation.scss'

import { Button } from 'react-bootstrap'
import {
  EVENT_CATEGORY_QUESTION,
  EVENT_CATEGORY_QUIZ,
  EVENT_ACTION_PAGEVIEW,
  EVENT_VALUE_SUMMARY,
  saveUserEvent
} from 'components/common/api/UserEvents'
import { useEffect } from 'react'

/**
 * Quiz Navigation component. Used for displaying subnavigation within a quiz.
 */
function QuizNavigation({
  activeQuestion,
  setActiveQuestion,
  questions,
  hasSummary
}) {
  const isFirstQuestion = activeQuestion === 0
  const isLastQuestion = activeQuestion === questions.length - 1
  const isSummary = activeQuestion === questions.length

  /**
   * Helper function to determine whether or not to show the "next" button
   */
  const shouldShowNext = () =>
    (!hasSummary && !isLastQuestion) || (hasSummary && !isSummary)

  /**
   * Helper function to handle setting the active question. Will return early if the index is out of bounds
   * @param {*} index
   */
  const handleSetActiveQuestion = index => {
    setActiveQuestion(index)
  }

  useEffect(() => {
    // No need to log navigation if we don't have questions
    // or if we're on the first question
    if (!questions || isFirstQuestion) return

    // Log quiz navigation
    const question = questions[activeQuestion]
    const category = isSummary ? EVENT_CATEGORY_QUIZ : EVENT_CATEGORY_QUESTION
    const value = isSummary ? EVENT_VALUE_SUMMARY : question?.question_id ?? 0

    saveUserEvent(category, EVENT_ACTION_PAGEVIEW, value)
  }, [questions, activeQuestion, isFirstQuestion, isSummary])

  return (
    <>
      <div className='quiz-navigation'>
        <div className='back'>
          {!isFirstQuestion && (
            <Button
              variant='secondary-outline'
              onClick={() => handleSetActiveQuestion(activeQuestion - 1)}
            >
              <i className='icon bi-arrow-left'></i> Back
            </Button>
          )}
        </div>
        <div>{/* Spacer */}</div>
        <div className='next'>
          {/* Don't show on last screen */}
          {shouldShowNext() && (
            <Button
              variant='secondary-outline'
              onClick={() => handleSetActiveQuestion(activeQuestion + 1)}
            >
              Next <i className='icon bi-arrow-right'></i>
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

export default QuizNavigation
